import React, { forwardRef, useCallback, useEffect, useMemo, useRef, useState } from 'react';

// HELPERS
import { useListData } from 'helpers/getListData';

// LOCAL COMPONENTS
import ListCardCollapse from './ListCardCollapse';
import LinkCell from '../../tools/LinkCell';

const ListCard = forwardRef(
  (
    {
      className, //
      index,
      mobilePreviewKeys,
      row: rowProp,
      setRowHeight,
      style: styleProp = {},
      ...props
    },
    ref
  ) => {
    // STATE
    const [resizeRowTrigger, setResizeRowTrigger] = useState(false);

    // REFS
    const cardRef = useRef({});

    // LIST CONTEXT
    const {
      result: rows = [],
      columns: rawColumns = [], //
      preferences: { showColumns } = {}
    } = {...(useListData() || {}), ...props};

    // MEMOS
    const columns = useMemo(() => {
      // Filter out any hidden columns
      const shown = showColumns ? rawColumns.filter(c => showColumns.includes(c.key)) : rawColumns;
      return shown.map(c => {
        if (c.to && !c.codes) c.component = LinkCell;
        return c;
      });
    }, [rawColumns, showColumns]);

    const style = useMemo(() => {
      const style = { ...styleProp };
      if (setRowHeight) style.height = 'auto';
      return style;
    }, [setRowHeight, styleProp]);

    // EFFECTS
    useEffect(() => {
      if (cardRef?.current && setRowHeight) {
        setRowHeight(index, cardRef.current.clientHeight, ref);
      }
    }, [index, ref, cardRef, setRowHeight, resizeRowTrigger]);

    // CALLBACKS
    const handleResizeRow = useCallback(() => {
      setTimeout(() => {
        setResizeRowTrigger(!resizeRowTrigger);
      }, 0);
    }, [resizeRowTrigger]);

    const row = rowProp || rows[index];

    return (
      <ListCardCollapse
        {...props}
        columns={columns}
        index={index}
        previewKeys={mobilePreviewKeys}
        resizeRow={handleResizeRow}
        ref={cardRef}
        row={row}
        style={style}
      />
    );
  }
);

// EXPORT
export default ListCard;
